import { Routes, Route, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useLayoutEffect, useState, useEffect } from 'react';
import Home from './pages/Home';
import BasicLayout from './components/Layout/BasicLayout';
import Auth from './pages/Auth';
import Profile from './pages/Profile';
import Projects from './pages/Projects';
import Inverters from './pages/Inverters';
import Devices from './pages/Devices';
import DeviceDebug from './pages/DeviceDebug';
import Users from './pages/Users';
import Firmware from './pages/Firmware';
import InverterModels from './pages/InverterModels';
import MqttLab from './pages/MqttLab';
import { auth_api } from './api/auth-api';
import { auth_actions } from './redux/modules/auth';
import LoadingSpin from './components/Loading/LoadingSpin';
import { setupMessageListener } from './utils/device-token';

function AppRouter() {
  const is_logined = useSelector(state => state.auth.is_logged_in);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (!!window.localStorage.getItem("api-token")) {
      setLoading(true);
      auth_api.getMe()
        .then(res => {
          console.log('AppRouter: getMe response:', res);
          if (res.success && res.user) {
            // Đảm bảo user data có đầy đủ các field
            const userData = {
              ...res.user,
              displayName: res.user.displayName || '',
              photoURL: res.user.photoURL || '',
              phoneNumber: res.user.phoneNumber || '',
              email: res.user.email || ''
            };
            console.log('AppRouter: Dispatching user data:', userData);
            dispatch(auth_actions.set_user(userData));
          } else {
            dispatch(auth_actions.logout());
          }
        })
        .catch(err => {
          console.error('Auth check error:', err);
          dispatch(auth_actions.logout());
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      dispatch(auth_actions.logout());
    }
  }, []); // eslint-disable-line

  // Setup FCM message listener khi user đã đăng nhập
  useEffect(() => {
    if (is_logined) {
      console.log('[AppRouter] Setting up FCM message listener...');
      setupMessageListener((payload) => {
        console.log('[AppRouter] FCM message received:', payload);
        // Có thể dispatch action hoặc hiển thị thông báo tại đây
      });
    }
  }, [is_logined]);

  return (
    <div>
      {loading && (
        <div style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: "rgba(255,255,255,0.8)",
          zIndex: 9999
        }} className="flex items-center justify-center">
          <LoadingSpin />
        </div>
      )}

      {
        is_logined ? (
          <BasicLayout>
            <Routes>
              <Route index element={<Navigate to="/" replace />} />
              <Route path="/" Component={Home} />
              <Route path="/profile" Component={Profile} />
              <Route path="/devices" Component={Devices} />
              <Route path="/devices/debug" Component={DeviceDebug} />
              <Route path="/inverters" Component={Inverters} />
              <Route path="/users" Component={Users} />
              <Route path="/projects" Component={Projects} />
              <Route path="/firmware" Component={Firmware} />
              <Route path="/inverter-models" Component={InverterModels} />
              <Route path="/mqtt" Component={MqttLab} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BasicLayout>
        ) : (
          <Routes>
            <Route path="/auth" Component={Auth} />
            <Route path="*" element={<Navigate to="/auth" replace />} />
          </Routes>
        )
      }
    </div>
  );
}

export default AppRouter;

